import styled, { css, keyframes } from "styled-components";
import { tombac } from "../../shared/tombac";
const tooltipVariants = tombac.variant("variant", {
  default: css(["background-color:", ";color:", ";"], tombac.color.white, tombac.color.black),
  danger: css(["background-color:", ";color:", ";"], tombac.color("danger", 400), tombac.color.white),
  inverted: css(["background-color:", ";color:", ";"], tombac.color.black, tombac.color.white)
});
const tooltipSizes = tombac.variant("size", {
  m: css(["padding:", ";"], tombac.space(2)),
  s: css(["padding:", ";"], tombac.space(1))
});
const TooltipAnimation = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
export const StyledTooltip = styled.div.withConfig({
  displayName: "TooltipStyles__StyledTooltip"
})(["all:initial;animation:", " 0.25s ease-in-out;border-radius:", ";box-sizing:border-box;display:flex;flex-direction:column;z-index:999999;box-shadow:", " rgba(0,0,0,16%);", ";", ";"], TooltipAnimation, tombac.unit(3), tombac.unit(0, 4, 16, 1), tooltipVariants, tooltipSizes);
//# sourceMappingURL=TooltipStyles.js.map